module.exports = __webpack_public_path__ + "static/img/137.0af9ac3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/137.png
// module id = dwSz
// module chunks = 0